import { CSSProperties, ReactElement } from 'react';

import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';
import AudioPlayer from '@backrs_ui/common-ui/src/assets/images/audio-player.png';

import { Theme, SxProps, Box, Typography } from '@mui/material';

type NuggetAudioProps = Readonly<{
  variant:
    | {
        type: 'SMALL';
      }
    | {
        type: 'LARGE';
        url: string;
        title: string;
      };
}>;

export const NuggetAudio = ({ variant }: NuggetAudioProps): ReactElement => {
  if (variant.type === 'LARGE') {
    return (
      <Box>
        <Typography
          sx={bottomTextStyle}
          variant="body1"
          onClick={() => window.open(variant.url, '_blank')}
        >
          {variant.title}
        </Typography>
        <Box sx={imageContainerStyle} onClick={() => window.open(variant.url, '_blank')}>
          <img src={AudioPlayer} alt="Audio Player" style={imageStyle} />
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={imageContainerStyle}>
      <img src={AudioPlayer} alt="Audio Player" style={imageStyle} />
    </Box>
  );
};

const imageContainerStyle: SxProps<Theme> = {
  borderRadius: '16px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden',
  width: '100%',
  maxHeight: '450px',
  height: 'auto',
  mt: 3,
  cursor: 'pointer',
};

const imageStyle: CSSProperties = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
};

const bottomTextStyle: SxProps<Theme> = {
  fontFamily: 'Sarabun',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
  mt: 2,
  textDecoration: 'underline',
  cursor: 'pointer',
  maxWidth: '100%',
  fontStyle: 'italic',
  color: appColors.color.blue1,
};
